export const noneg = (value: number) => (value > 0 ? value : 0)
